<template>
  <div class="w-100">
    <div
      class="w-100 d-flex py-md-0 px-md-5 align-items-start justify-content-center"
      :class="[inMobileWebView() ? 'no-header-space' : 'header-space']">
      <div>
        <h6
          v-if="pageHeader"
          class="text-center"
          :class="{'marketing': !isMobile}">
          {{ pageHeader }}
        </h6>
        <h4
          v-if="pageSubheader"
          class="text-center px-4 mb-0 mt-md-2">
          {{ pageSubheader }}
        </h4>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inMobileWebView } from '@/utils/mobileApp.js'

defineProps({
  pageHeader: {
    type: String,
    default: null
  },
  pageSubheader: {
    type: String,
    default: null
  }
})
</script>

<style lang="scss" scoped>
.no-header-space {
  padding-top: 1rem !important;
}
.header-space {
  padding-top: 7rem !important;
}
</style>
